<main class="check">
  <header [attr.id]="data.title">
    <h3 [class.error]="!data.isPassed">{{ data.title }}</h3>
  </header>

  <section
    class="check-cases"
    [class.border]="data.main.isApplicable"
    [attr.id]="data.main.title"
  >
    <mat-slide-toggle
      [color]="data.main.isPassed ? 'primary' : 'warn'"
      [(ngModel)]="data.main.isApplicable"
      (change)="onDataChange()"
      *ngIf="!(readonly || printPreview)"
    >
      <span
        class="title"
        [class.error]="data.main.isApplicable && !data.main.isPassed"
        >{{ data.main.title }}</span
      >
    </mat-slide-toggle>
    <span
      class="title"
      [class.error]="data.main.isApplicable && !data.main.isPassed"
      *ngIf="readonly || printPreview"
      >{{ data.main.title }}
    </span>
    <div class="cases" *ngIf="data.main.isApplicable; else notApplicable">
      <authority-labs-check-value-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="data.main.hubLocation"
        [fieldSection]="data.main.title"
      ></authority-labs-check-value-case>
      <authority-labs-check-value-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="data.main.hubMadeFrom"
        [fieldSection]="data.main.title"
      ></authority-labs-check-value-case>
      <authority-labs-check-value-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="data.main.hubModel"
        [fieldSection]="data.main.title"
      ></authority-labs-check-value-case>
      <authority-labs-check-value-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="data.main.detectionSystemTestedBy"
        [fieldSection]="data.main.title"
      ></authority-labs-check-value-case>
      <authority-labs-check-value-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="data.main.protectedAreas"
        [fieldSection]="data.main.title"
      ></authority-labs-check-value-case>
      <authority-labs-check-value-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="data.main.siteRiskLevel"
        [fieldSection]="data.main.title"
      ></authority-labs-check-value-case>
    </div>
  </section>

  <div *ngIf="printPreview">
    <mat-card
      class="mat-elevation-z4"
      *ngFor="let area of data.areas; let ind = index"
    >
      <mat-card-header>
        <mat-card-title>{{ tabName(ind) }}</mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <ng-container
          *ngTemplateOutlet="formTpl; context: { area: area, ind: ind }"
        ></ng-container>
      </mat-card-content>
    </mat-card>
  </div>
  <mat-tab-group
    class="mat-elevation-z4"
    [(selectedIndex)]="selectedTab"
    *ngIf="!printPreview"
  >
    <mat-tab *ngFor="let area of data.areas; let ind = index">
      <ng-template mat-tab-label>
        <mat-icon class="fail" color="warn" *ngIf="!area.aerosol.isPassed">
          priority_high
        </mat-icon>
        <span>{{ tabName(ind) }}</span>
      </ng-template>
      <ng-template matTabContent>
        <div [style.margin-right]="readonly || printPreview ? '45px' : '0'">
          <ng-container
            *ngTemplateOutlet="formTpl; context: { area: area, ind: ind }"
          ></ng-container>
        </div>
        <section *ngIf="!(readonly || printPreview)">
          <button
            class="btn remove-btn"
            mat-raised-button
            aria-label="remove"
            [disabled]="data.areas.length === 1"
            (click)="removeTest()"
          >
            <span>הסר</span>
          </button>
          <button
            class="btn add-btn"
            mat-raised-button
            color="accent"
            aria-label="duplicate"
            (click)="duplicateTest()"
          >
            <span>שכפל בדיקה נוכחית</span>
          </button>
          <button
            class="btn add-btn"
            mat-raised-button
            color="accent"
            aria-label="add"
            (click)="addTest()"
          >
            <span>הוסף בדיקה</span>
          </button>
        </section>
      </ng-template>
    </mat-tab>
  </mat-tab-group>
</main>

<ng-template #formTpl let-area="area" let-ind="ind">
  <section
    class="check-cases"
    [class.border]="area.aerosol.isApplicable"
    [attr.id]="area.aerosol.title"
  >
    <mat-slide-toggle
      [color]="area.aerosol.isPassed ? 'primary' : 'warn'"
      [(ngModel)]="area.aerosol.isApplicable"
      (change)="onDataChange()"
      *ngIf="!(readonly || printPreview)"
    >
      <span
        class="title"
        [class.error]="area.aerosol.isApplicable && !area.aerosol.isPassed"
        >{{ area.aerosol.title }}</span
      >
    </mat-slide-toggle>
    <span
      class="title"
      [class.error]="area.aerosol.isApplicable && !area.aerosol.isPassed"
      *ngIf="readonly || printPreview"
      >{{ area.aerosol.title }}
    </span>
    <div class="cases" *ngIf="area.aerosol.isApplicable; else notApplicable">
      <authority-labs-check-value-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="area.aerosol.basedOnPrEngineerSystem"
        [fieldSection]="area.aerosol.title"
      ></authority-labs-check-value-case>
      <authority-labs-check-value-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="area.aerosol.boardDetailsOrProtectedSpace"
        [fieldSection]="area.aerosol.title"
      ></authority-labs-check-value-case>
      <authority-labs-check-dimensions-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="area.aerosol.boardDimensions"
        [fieldSection]="area.aerosol.title"
      ></authority-labs-check-dimensions-case>
    </div>
  </section>

  <section
    class="check-cases"
    [class.border]="area.shutdownComponents.isApplicable"
    [attr.id]="area.shutdownComponents.title"
  >
    <mat-slide-toggle
      [color]="area.shutdownComponents.isPassed ? 'primary' : 'warn'"
      [(ngModel)]="area.shutdownComponents.isApplicable"
      (change)="onDataChange()"
      *ngIf="!(readonly || printPreview)"
    >
      <span
        class="title"
        [class.error]="
          area.shutdownComponents.isApplicable &&
          !area.shutdownComponents.isPassed
        "
        >{{ area.shutdownComponents.title }}</span
      >
    </mat-slide-toggle>
    <span
      class="title"
      [class.error]="
        area.shutdownComponents.isApplicable &&
        !area.shutdownComponents.isPassed
      "
      *ngIf="readonly || printPreview"
      >{{ area.shutdownComponents.title }}
    </span>
    <div
      class="cases"
      *ngIf="area.shutdownComponents.isApplicable; else notApplicable"
    >
      <authority-labs-check-value-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="area.shutdownComponents.item_7_1"
        [fieldSection]="area.shutdownComponents.title"
      ></authority-labs-check-value-case>
      <authority-labs-check-value-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="area.shutdownComponents.item_7_2"
        [fieldSection]="area.shutdownComponents.title"
      ></authority-labs-check-value-case>
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="area.shutdownComponents.item_7_3"
        [fieldSection]="area.shutdownComponents.title"
      ></authority-labs-check-case>
      <authority-labs-check-value-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="area.shutdownComponents.item_7_4"
        [fieldSection]="area.shutdownComponents.title"
      ></authority-labs-check-value-case>
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="area.shutdownComponents.item_7_5"
        [fieldSection]="area.shutdownComponents.title"
      ></authority-labs-check-case>
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="area.shutdownComponents.item_7_6"
        [fieldSection]="area.shutdownComponents.title"
      ></authority-labs-check-case>
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="area.shutdownComponents.item_7_7"
        [fieldSection]="area.shutdownComponents.title"
      ></authority-labs-check-case>
    </div>
  </section>

  <section
    class="check-cases"
    [class.border]="area.installationRequirements.isApplicable"
    [attr.id]="area.installationRequirements.title"
  >
    <mat-slide-toggle
      [color]="area.installationRequirements.isPassed ? 'primary' : 'warn'"
      [(ngModel)]="area.installationRequirements.isApplicable"
      (change)="onDataChange()"
      *ngIf="!(readonly || printPreview)"
    >
      <span
        class="title"
        [class.error]="
          area.installationRequirements.isApplicable &&
          !area.installationRequirements.isPassed
        "
        >{{ area.installationRequirements.title }}</span
      >
    </mat-slide-toggle>
    <span
      class="title"
      [class.error]="
        area.installationRequirements.isApplicable &&
        !area.installationRequirements.isPassed
      "
      *ngIf="readonly || printPreview"
      >{{ area.installationRequirements.title }}
    </span>
    <div
      class="cases"
      *ngIf="area.installationRequirements.isApplicable; else notApplicable"
    >
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="area.installationRequirements.item_8_1"
        [fieldSection]="area.installationRequirements.title"
      ></authority-labs-check-case>
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="area.installationRequirements.item_8_2"
        [fieldSection]="area.installationRequirements.title"
      ></authority-labs-check-case>
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="area.installationRequirements.item_8_3"
        [fieldSection]="area.installationRequirements.title"
      ></authority-labs-check-case>
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="area.installationRequirements.item_8_4"
        [fieldSection]="area.installationRequirements.title"
      ></authority-labs-check-case>
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="area.installationRequirements.item_8_5"
        [fieldSection]="area.installationRequirements.title"
      ></authority-labs-check-case>
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="area.installationRequirements.item_8_6"
        [fieldSection]="area.installationRequirements.title"
      ></authority-labs-check-case>
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="area.installationRequirements.item_8_7"
        [fieldSection]="area.installationRequirements.title"
      ></authority-labs-check-case>
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="area.installationRequirements.item_8_8"
        [fieldSection]="area.installationRequirements.title"
      ></authority-labs-check-case>
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="area.installationRequirements.item_8_9"
        [fieldSection]="area.installationRequirements.title"
      ></authority-labs-check-case>
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="area.installationRequirements.item_8_10"
        [fieldSection]="area.installationRequirements.title"
      ></authority-labs-check-case>
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="area.installationRequirements.item_8_11"
        [fieldSection]="area.installationRequirements.title"
      ></authority-labs-check-case>
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="area.installationRequirements.item_8_12"
        [fieldSection]="area.installationRequirements.title"
      ></authority-labs-check-case>
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="area.installationRequirements.item_8_13"
        [fieldSection]="area.installationRequirements.title"
      ></authority-labs-check-case>
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="area.installationRequirements.item_8_14"
        [fieldSection]="area.installationRequirements.title"
      ></authority-labs-check-case>
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="area.installationRequirements.item_8_15"
        [fieldSection]="area.installationRequirements.title"
      ></authority-labs-check-case>
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="area.installationRequirements.item_8_16"
        [fieldSection]="area.installationRequirements.title"
      ></authority-labs-check-case>
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="area.installationRequirements.item_8_17"
        [fieldSection]="area.installationRequirements.title"
      ></authority-labs-check-case>
    </div>
  </section>

  <section
    class="check-cases"
    [class.border]="area.markupRequirements.isApplicable"
    [attr.id]="area.markupRequirements.title"
  >
    <mat-slide-toggle
      [color]="area.markupRequirements.isPassed ? 'primary' : 'warn'"
      [(ngModel)]="area.markupRequirements.isApplicable"
      (change)="onDataChange()"
      *ngIf="!(readonly || printPreview)"
    >
      <span
        class="title"
        [class.error]="
          area.markupRequirements.isApplicable &&
          !area.markupRequirements.isPassed
        "
        >{{ area.markupRequirements.title }}</span
      >
    </mat-slide-toggle>
    <span
      class="title"
      [class.error]="
        area.markupRequirements.isApplicable &&
        !area.markupRequirements.isPassed
      "
      *ngIf="readonly || printPreview"
      >{{ area.markupRequirements.title }}
    </span>
    <div
      class="cases"
      *ngIf="area.markupRequirements.isApplicable; else notApplicable"
    >
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="area.markupRequirements.item_9_1"
        [fieldSection]="area.markupRequirements.title"
      ></authority-labs-check-case>
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="area.markupRequirements.item_9_2"
        [fieldSection]="area.markupRequirements.title"
      ></authority-labs-check-case>
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="area.markupRequirements.item_9_3"
        [fieldSection]="area.markupRequirements.title"
      ></authority-labs-check-case>
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="area.markupRequirements.item_9_4"
        [fieldSection]="area.markupRequirements.title"
      ></authority-labs-check-case>
    </div>
  </section>

  <section
    class="check-cases"
    [class.border]="area.aerosolInstallation.isApplicable"
    [attr.id]="area.aerosolInstallation.title"
  >
    <mat-slide-toggle
      [color]="area.aerosolInstallation.isPassed ? 'primary' : 'warn'"
      [(ngModel)]="area.aerosolInstallation.isApplicable"
      (change)="onDataChange()"
      *ngIf="!(readonly || printPreview)"
    >
      <span
        class="title"
        [class.error]="
          area.aerosolInstallation.isApplicable &&
          !area.aerosolInstallation.isPassed
        "
        >{{ area.aerosolInstallation.title }}</span
      >
    </mat-slide-toggle>
    <span
      class="title"
      [class.error]="
        area.aerosolInstallation.isApplicable &&
        !area.aerosolInstallation.isPassed
      "
      *ngIf="readonly || printPreview"
      >{{ area.aerosolInstallation.title }}
    </span>
    <div
      class="cases"
      *ngIf="area.aerosolInstallation.isApplicable; else notApplicable"
    >
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="area.aerosolInstallation.item_10_1"
        [fieldSection]="area.aerosolInstallation.title"
      ></authority-labs-check-case>
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="area.aerosolInstallation.item_10_2"
        [fieldSection]="area.aerosolInstallation.title"
      ></authority-labs-check-case>
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="area.aerosolInstallation.item_10_3"
        [fieldSection]="area.aerosolInstallation.title"
      ></authority-labs-check-case>
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="area.aerosolInstallation.item_10_4"
        [fieldSection]="area.aerosolInstallation.title"
      ></authority-labs-check-case>
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="area.aerosolInstallation.item_10_5"
        [fieldSection]="area.aerosolInstallation.title"
      ></authority-labs-check-case>
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="area.aerosolInstallation.item_10_6"
        [fieldSection]="area.aerosolInstallation.title"
      ></authority-labs-check-case>
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="area.aerosolInstallation.item_10_7"
        [fieldSection]="area.aerosolInstallation.title"
      ></authority-labs-check-case>
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="area.aerosolInstallation.item_10_8"
        [fieldSection]="area.aerosolInstallation.title"
      ></authority-labs-check-case>
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="area.aerosolInstallation.item_10_9"
        [fieldSection]="area.aerosolInstallation.title"
      ></authority-labs-check-case>
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="area.aerosolInstallation.item_10_10"
        [fieldSection]="area.aerosolInstallation.title"
      ></authority-labs-check-case>
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="area.aerosolInstallation.item_10_11"
        [fieldSection]="area.aerosolInstallation.title"
      ></authority-labs-check-case>
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="area.aerosolInstallation.item_10_12"
        [fieldSection]="area.aerosolInstallation.title"
      ></authority-labs-check-case>
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="area.aerosolInstallation.item_10_13"
        [fieldSection]="area.aerosolInstallation.title"
      ></authority-labs-check-case>
    </div>
  </section>
</ng-template>

<ng-template #notApplicable>
  <mat-radio-group disabled="true" class="print-preview" *ngIf="printPreview">
    <mat-radio-button checked="false">מתאים</mat-radio-button>
    <mat-radio-button checked="false">לא מתאים</mat-radio-button>
    <mat-radio-button value="true" checked="true">לא ישים</mat-radio-button>
  </mat-radio-group>
</ng-template>
